<template>
  <div style="width:100%;height:100%;">
    <el-container style="width:100%;height:100%;">
      <el-header>
        <h1 class="header_logo">
          <a class="logo_link" link="#"></a>
        </h1>
        <el-menu :default-active="activeIndex" class="el-menu-demo header_nav_wrap" mode="horizontal"
          @select="clickMenuNav">
          <el-menu-item index="1">概览</el-menu-item>
          <el-menu-item index="2">工作任务</el-menu-item>
          <el-menu-item index="3" v-if="info.role != 15 && info.role != 16">客户档案</el-menu-item>
          <el-menu-item index="8" v-if="isAdmin || isOrder">销售订单</el-menu-item>
          <!-- <el-menu-item index="6" v-if="isAdmin || isFront">前台流量</el-menu-item> -->
          <el-menu-item index="7" v-if="isFlow">客流管理</el-menu-item>
          <el-menu-item index="9" v-if="isFlowStatistics">客流统计</el-menu-item>
          <el-menu-item index="4" v-if="isAdmin">
            <img src="../../assets/img/big.png" class="big" />
            <img src="../../assets/img/new.gif" class="new" />
          </el-menu-item>
          <el-menu-item index="5" v-if="isAdmin || isManager">团队管理</el-menu-item>
        </el-menu>
        <div class="header_person">
          <span class="dealer_name">{{ info.profile.company }}</span>
          <el-dropdown trigger="click" placement="bottom">
            <span class="el-dropdown-link">
              {{ info.profile.name }}
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="header_profile_menu">
              <el-dropdown-item @click.native="showProfileDialog">
                <span style="width:140px;display:block;float:left;">
                  <i class="fa fa-user-circle-o" aria-hidden="true"></i>&nbsp;
                  个人信息
                </span>
                <i class="el-icon-arrow-right"></i>
              </el-dropdown-item>
              <el-dropdown-item @click.native="showChangePasswordDialog">
                <span style="width:140px;display:block;float:left;">
                  <i class="fa fa-key" aria-hidden="true"></i>&nbsp; 修改密码
                </span>
                <i class="el-icon-arrow-right"></i>
              </el-dropdown-item>
              <el-dropdown-item @click.native="isSwitch = true" v-if="swichData.role == 2 ||
                swichData.role == 9 ||
                swichData.role == 3 ||
                swichData.role == 11
                ">
                <span style="width:140px;display:block;float:left;">
                  <i class="fa fa-key" aria-hidden="true"></i>&nbsp; 切换门店
                </span>
                <i class="el-icon-arrow-right"></i>
              </el-dropdown-item>
              <el-dropdown-item @click.native="doLogout" divided>
                <span style="width:140px;display:block;float:left;">
                  <i class="fa fa-sign-out" aria-hidden="true"></i>&nbsp;
                  退出登录
                </span>
                <i class="el-icon-arrow-right"></i>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main style="width: 100%;flex: 1;position: relative;padding: 0;overflow: hidden;">
        <router-view></router-view>
      </el-main>
    </el-container>
    <el-dialog title="个人信息" :visible.sync="profileDialog" width="350px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form label-position="right" label-width="100px">
        <el-form-item class="form_item" label="姓名">{{
          user.name
        }}</el-form-item>
        <el-form-item class="form_item" label="手机号">{{
          user.mobile
        }}</el-form-item>
        <el-form-item class="form_item" label="身份证号">{{
          user.identifyNo
        }}</el-form-item>
        <el-form-item class="form_item" label="经销商">{{
          info.profile.company
        }}</el-form-item>
        <el-form-item class="form_item" label="角色">{{
          info.profile.roleName
        }}</el-form-item>
        <!-- <el-form-item
          class="form_item"
          label="加入时间"
        >{{dealer.createdAt | parseTime('{y}年{m}月{d}日')}}</el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="profileDialog = false" type="text">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="changePasswordDialog" width="350px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="changePasswordForm" :model="changePasswordForm" :rules="changePasswordFormRules" class="common_form"
        label-position="right" label-width="100px">
        <el-form-item class="form_item_val" label="旧密码" prop="oldPassword">
          <el-input size="small" type="password" style="width: 200px;"
            v-model="changePasswordForm.oldPassword"></el-input>
          <!-- <span class="click_link">发送验证码</span> -->
        </el-form-item>
        <el-form-item class="form_item_val" label="新密码" prop="newPassword">
          <el-input size="small" type="password" style="width: 200px;"
            v-model="changePasswordForm.newPassword"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doChangePassword" style="margin-right:30px;" type="text">保存</el-button>
        <el-button @click="changePasswordDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="切换门店" :visible.sync="isSwitch" width="400px" class="swichlog" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-radio-group v-model="checkId">
        <div v-for="(row, index) in dealersList" :key="index">
          <div style="font-size: 13px; font-weight: bold; margin-bottom: 10px;" :style="{marginTop: index == 0 ? '0' : '10px'}">
            <span style="margin-right: 20px;">手机号：{{ row.mobile }}</span>
            <span>工号：{{ row.empNo }}</span>
          </div>
          <el-radio :label="`${item.dealerId}-${row.userId}`" v-for="(item, index) in row.dealerInfo" :key="index"
            :disabled="`${dealer.dealerId}-${dealer.userId}` == `${item.dealerId}-${row.userId}`">{{ item.name }}</el-radio>
        </div>
      </el-radio-group>

      <span slot="footer" class="dialog-footer">
        <el-button @click="switchDealer" type="text">确定</el-button>
        <el-button @click="isSwitch = false" type="text">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapGetters, mapActions } from 'vuex'
import { casLogout, dealerNetMap } from '@/assets/js/constant'
import { getExplore } from '@/assets/js/util'
import { deviceTypeMap } from "@/assets/js/commonMap.js";
const explore = getExplore()

export default {
  data() {
    return {
      activeIndex: "1",
      loginInfo: this.$common.getLoginInfo() ||{},
      isAdmin: this.$common.getAdmin(),
      isFront: false,
      isManager: false,
      isOrder: false,
      isFlow: false,
      isFlowStatistics: false,
      profileDialog: false,
      changePasswordDialog: false,
      changePasswordForm: {
        code: "",
        newPassword: "",
      },
      user: this.$common.getDealer(),
      dealer: this.$common.getDealer() ||{},
      info: this.$common.getLoginInfo() ||{},
      changePasswordFormRules: {
        oldPassword: [
          {
            required: true,
            message: "请输入旧密码",
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 12,
            message: "密码长度应在6-12位",
            trigger: "blur",
          },
        ],
      },
      isSwitch: false,
      swichData: this.$common.getLoginInfo(),
      checkId: null,
      form: {
        deviceType: '',
        deviceVersion: '', // 操作系统版本 window11
        device: `${explore.name} ${explore.fullVersion}`, // 浏览器类型
      },
      dccVirtualDealer: ''
    };
  },
  computed: {
    ...mapGetters('common', ['osInfo']),
    // 过滤DCC虚拟门店 虚拟门店不允许切换
    dealersList() {
      const value = this.swichData.allDealers.map(item => { 
        item.dealerInfo = item.dealerInfo.filter(otem => otem.dealerId !== this.dccVirtualDealer)
        return  item
      });
      return value;
    }
  },
  async created() {
    await this.getModernOSInfo()
    const { name, versionName } = this.osInfo
    this.form.deviceVersion = versionName
    this.form.deviceType = name
    const { dealerId, userId } = this.$common.getDealer();
    this.checkId = `${dealerId}-${userId}`
    this.getDccVirtualDealer();
  },
  mounted() {
    this.loginInfo.allModules.forEach((item) => {
      if (item.name == "前台流量") {
        this.isFront = true;
      }
      if (item.name == "公司管理") {
        this.isManager = true;
      }
      if (item.name == "销售订单") {
        this.isOrder = true;
      }
      if (item.name === '客流管理') {
        this.isFlow = true
      }
      if (item.name === '客流统计') {
        this.isFlowStatistics = true
      }
    });
    // const loading = this.$loading({
    //     lock: true,
    //     text: '加载中...',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(213,217,220,.84)'
    // });
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.path.startWith("/dashboard/")) {
        vm.activeIndex = "1";
      }
      if (to.path.startWith("/activity/")) {
        vm.activeIndex = "2";
      }
      if (to.path.startWith("/customer/")) {
        vm.activeIndex = "3";
      }
      if (to.path.startWith("/report/")) {
        vm.activeIndex = "4";
      }
      if (to.path.startWith("/manager/")) {
        vm.activeIndex = "5";
      }
      if (to.path.startWith("/front/")) {
        vm.activeIndex = "6";
      }
      if (to.path.startWith("/customer-flow/")) {
        vm.activeIndex = "7";
      }
      if (to.path.startWith("/order")) {
        vm.activeIndex = "8";
      }
      if (to.path.startWith("/customer-flowStatistics/list")) {
        vm.activeIndex = "9";
      }
      // if (to.path.startWith("/agent/")) {
      //   vm.activeIndex = "9";
      // }
    });
  },
  methods: {
    ...mapActions('common', ['getDealerCodeGray', 'getModernOSInfo']),
    
    switchDealer() {
      const [ dealerId, userId ] = this.checkId.split('-').map(Number);
      const refreshToken = Cookies.get("Dealer-User-RefreshToken");
      this.$httpAuth
        .post("/v2/appUserService/switchDealer", {
          dealerId,
          userId,
          refreshToken,
          ...this.getParams()
        })
        .then((res) => {
          this.swichData = { ...res.data };
          const { token, refreshToken = '', profile, isAdmin } = res.data
          Cookies.set("Dealer-User-Token", token);
          Cookies.set("Dealer-User-RefreshToken", refreshToken);
          this.$common.setDealer(profile);
          this.$common.setAdmin(isAdmin);
          this.$common.setLoginInfo(res.data);
          this.info = res.data;
          this.dealer = this.$common.getDealer() || {};
          this.$httpAuth
            .post("/v2/appBaseService/info", { token: process.env.VUE_APP_INFO_TOKEN })
            .then(res=>{
              this.isSwitch = false;
              this.$common.setBaseInfo(res.data);
              this.$router.push('/dashboard/index');
            })
            .catch(() => {
              that.isSwitch = false;
            });
          console.log(this.swichData);
        });
    },
    getParams() {
      const { device, deviceVersion, deviceType } = this.form
      let value = {
        device,
        deviceType: deviceTypeMap.get(deviceType) ?? 0, // deviceType：0 pc windows, 1 ANDROID 2: ios 3.小程序 4. 鸿蒙 5 pc mac
        deviceVersion,
      }
      return value
    },
    getProfile() {
      this.$httpAuth
        .post("/v1/userRpc/profile", {})
        .then((response) => {
          this.$common.setUser(response.data.profile || {});
          this.user = response.data.profile;
        })
        .catch(() => {
        });
    },
    clickMenuNav(index) {
      if (index == "1") {
        this.$router.push({
          path: "/dashboard/index",
        });
      }
      if (index == "2") {
        if (this.info.role != 15 && this.info.role != 16) {
          this.$router.push({
            path: "/activity/tasks",
          });
        } else {
          // this.$router.push({
          //   path: "/activity/bussiness-clue",
          // });
        }
      }
      if (index == "3") {
        this.$router.push({
          path: "/customer/list",
        });
      }
      if (index == "4") {
        this.$router.push({
          path: "/report/bigScreen",
        });
      }
      if (index == "5") {
        this.$router.push({
          path: "/manager/members",
        });
      }
      if (index == "6") {
        this.$router.push({
          path: "/front/index",
        });
      }
      if (index == "7") {
        this.$router.push({
          path: "/customer-flow/list",
        });
      }
      if (index == "8") {
        this.$router.push({
          path: "/order/zzOrder",
        });
      }
      if (index == '9') {
        this.$router.push({
          path: "/customer-flowStatistics/list",
        });
      }
    },
    showProfileDialog() {
      this.getProfile()
      this.profileDialog = true;
    },
    showChangePasswordDialog() {
      this.changePasswordForm = {
        oldPassword: "",
        newPassword: "",
      };
      if (this.$refs["changePasswordForm"]) {
        this.$refs["changePasswordForm"].resetFields();
      }
      this.changePasswordDialog = true;
    },
    doLogout() {
      const refreshToken = Cookies.get("Dealer-User-RefreshToken");
      this.$httpAuth
        .post("/v2/appUserService/logout", { refreshToken })
        .then((response) => {
        })
        .catch(() => {
        });
      Cookies.set("Dealer-User-Token", "");
      Cookies.set("Dealer-User-RefreshToken", "");
      // this.$common.removeDealer()
      // this.$router.push({
      //   path: "/login",
      // });
      try {
          const dealer = this.$common.getDealer() || {}
          const { dealerCode, type } = dealer
          if(dealerCode) {
            this.getDealerCodeGray({dealerCode, dealerNet: dealerNetMap.get(type) })
              .then(grayres=> {
                this.$common.removeDealer()
                if(grayres?.data?.status === 1 && grayres?.data?.data) {
                  casLogout()
                } else {
                  this.$router.push({
                    path: "/login",
                  });
                }
              }).catch(()=> {
                this.$router.push({
                  path: "/login",
                });
              })
          } else {
            this.$router.push({
              path: "/login",
            });
          }    
        } catch (error) {
          this.$router.push({
            path: "/login",
          });
        }


      // let href = `${location.origin}${location.pathname}#/login`
      // location.href = href
      // this.$router.replace({
      //   path: "/login",
      // });
      // this.$httpAuth
      //   .post("/v2/appUserService/logout", {
      //   })
      //   .then((res) => {
      //     Cookies.set("Dealer-User-Token", "");
      //     this.$router.push({
      //       path: "/login",
      //     });
      //   });
    },
    doChangePassword() {
      this.$refs["changePasswordForm"].validate((valid) => {
        if (valid) {
          var parent = this;
          this.$httpAuth
            .post("/v1/userRpc/changePassword", {
              oldPassword: this.$common.md5(
                this.changePasswordForm.oldPassword
              ),
              newPassword: this.$common.md5(
                this.changePasswordForm.newPassword
              ),
            })
            .then(function () {
              parent.$message({
                message: "密码修改成功",
                type: "success",
              });
              parent.changePasswordDialog = false;
            })
            .catch(() => { });
        }
      });
    },
    getDccVirtualDealer() {
      this.$httpAuth
        .post("/v2/appCustomerService/getDccVirtualDealer", {})
        .then((response) => {
          this.dccVirtualDealer = response.data.dealerId;
        })
        .catch(() => { });
    }
  },
};
</script>

<style>
.el-main {
  padding-top: 0px;
  padding-left: 0px;
  padding-right: 0px;
}

.big {
  width: 60px;
}

.new {
  width: 35px;
  position: absolute;
  top: 10px;
  right: -1px;
}

.el-header {
  background-color: #f0f2f3;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.12),
    0 10px 12px 0 rgba(170, 182, 206, 0.2),
    inset 0 -1px 0 0 rgba(255, 255, 255, 0.3);
}

.header_nav_wrap {
  float: left;
  margin-left: 10px;
  background-color: rgba(0, 0, 0, 0);
}

.header_nav_wrap .is-active {
  background-color: white;
}

.header_nav_wrap .el-menu-item {
  padding: 0 15px;
  font-weight: 500;
}

.header_person {
  float: right;
  margin-right: 8px;
  height: 60px;
  line-height: 60px;
}

.header_person .dealer_name {
  font-size: 13px;
  font-weight: 700;
}

.header_person .el-dropdown-link {
  font-size: 13px;
  font-weight: 700;
  color: #5182e4;
}

.header_profile_menu {
  width: 200px;
}
</style>
